import { isString } from '@/utils/checks'
import { PageType, Page, TAXONOMY_PAGES } from '@/types/models/PageType.model'

interface PageTypeCheck {
  (pageType?: PageType): boolean
}

export const isFacetPageType: PageTypeCheck = (pageType) => {
  return isString(pageType) && pageType.includes(Page.FACET_LOCATION)
}

export const isLocationPageType: PageTypeCheck = (pageType) => {
  return pageType === Page.LOCATION
}

export const isLuxuryFacetPageType = (
  pageType?: PageType,
  path?: string
): boolean => {
  return (
    isString(pageType) &&
    isFacetPageType(pageType) &&
    isString(path) &&
    path.includes('luxury')
  )
}

export const isTaxonomyPageType: PageTypeCheck = (pageType) => {
  return isString(pageType) && TAXONOMY_PAGES.includes(pageType as Page)
}

export const isConditionPageType: PageTypeCheck = (pageType = '') => {
  return pageType === Page.CONDITION
}

export const isConditionFacetPageType: PageTypeCheck = (pageType = '') => {
  return isFacetPageType(pageType) && pageType.includes(Page.CONDITION)
}

export const isClientelePageType: PageTypeCheck = (pageType = '') => {
  return pageType === Page.CLIENTELE
}

export const isClienteleFacetPageType: PageTypeCheck = (pageType = '') => {
  return isFacetPageType(pageType) && pageType.includes(Page.CLIENTELE)
}

export const isLevelsOfCarePageType: PageTypeCheck = (pageType = '') => {
  return pageType === Page.CARE
}

export const isLevelsOfCareFacetPageType: PageTypeCheck = (pageType = '') => {
  return isFacetPageType(pageType) && pageType.includes(Page.CARE)
}

export const isInsurancePageType: PageTypeCheck = (pageType = '') => {
  return pageType === Page.INSURANCE
}

export const isInsuranceFacetPageType: PageTypeCheck = (pageType = '') => {
  return isFacetPageType(pageType) && pageType.includes(Page.INSURANCE)
}

export const isResourcesPageType: PageTypeCheck = (pageType = '') => {
  return pageType === Page.RESOURCES
}

export const isBrowsePageType: PageTypeCheck = (pageType = '') => {
  return pageType === Page.BROWSE
}

export const isUtilitiesPageType: PageTypeCheck = (pageType = '') => {
  return pageType === Page.UTILITIES
}

export const isTherapyPageType: PageTypeCheck = (pageType = '') => {
  return pageType === Page.THERAPY
}

export const isTherapyFacetPageType: PageTypeCheck = (pageType = '') => {
  return isFacetPageType(pageType) && pageType.includes(Page.THERAPIES)
}

export const isSpecialConsiderationsPageType: PageTypeCheck = (
  pageType = ''
) => {
  return pageType === Page.SPECIAL_CONSIDERATION
}

export const isSpecialConsiderationsFacetPageType: PageTypeCheck = (
  pageType = ''
) => {
  return (
    isFacetPageType(pageType) && pageType.includes(Page.SPECIAL_CONSIDERATION)
  )
}

export const isApproachPageType: PageTypeCheck = (pageType = '') => {
  return pageType === Page.APPROACH
}

export const isApproachFacetPageType: PageTypeCheck = (pageType = '') => {
  return isFacetPageType(pageType) && pageType.includes(Page.APPROACHES)
}

export const isSettingPageType: PageTypeCheck = (pageType = '') => {
  return pageType === Page.SETTING
}

export const isSettingFacetPageType: PageTypeCheck = (pageType = '') => {
  return isFacetPageType(pageType) && pageType.includes(Page.SETTING)
}

export const isAmenitiesPageType: PageTypeCheck = (pageType = '') => {
  return pageType === Page.AMENITIES
}

export const isAmenitiesFacetPageType: PageTypeCheck = (pageType = '') => {
  return isFacetPageType(pageType) && pageType.includes(Page.AMENITIES)
}

export const isPricePageType: PageTypeCheck = (pageType = '') => {
  return pageType === Page.PRICE
}

export const isPriceFacetPageType: PageTypeCheck = (pageType = '') => {
  return isFacetPageType(pageType) && pageType.includes(Page.PRICE)
}

export const isActivitiesPageType: PageTypeCheck = (pageType = '') => {
  return pageType === Page.ACTIVITY
}

export const isCareersPageType: PageTypeCheck = (pageType = '') => {
  return pageType === Page.CAREERS
}

export const isActivitiesFacetPageType: PageTypeCheck = (pageType = '') => {
  return isFacetPageType(pageType) && pageType.includes(Page.ACTIVITIES)
}

export const isAcceptedInsuranceFacetPageType: PageTypeCheck = (
  pageType = ''
) => {
  return (
    isString(pageType) &&
    isFacetPageType(pageType) &&
    isInsuranceFacetPageType(pageType)
  )
}

export const isInsurancePage = (pageType: PageType) =>
  isInsurancePageType(pageType) ||
  isAcceptedInsuranceFacetPageType(pageType) ||
  isInsuranceFacetPageType(pageType)

export const isCenterProfilePageType: PageTypeCheck = (pageType = '') => {
  return pageType === Page.CENTER_PROFILE
}

export const isBrandProfilePageType: PageTypeCheck = (pageType = '') => {
  return pageType === Page.BRAND_PROFILE
}

export const isLanguagePageType: PageTypeCheck = (pageType = '') => {
  return pageType === Page.LANGUAGE
}

export const isLanguageFacetPageType: PageTypeCheck = (pageType = '') => {
  return isFacetPageType(pageType) && pageType.includes(Page.LANGUAGES)
}
